<!-- For camera -->
<ngx-scanner-qrcode
  #action="scanner"
  (event)="onEvent($event, action)"
></ngx-scanner-qrcode>

<!-- data  -->
<!-- <span>{{ action.data.value[0]?.value | json }}</span -->
<!-- value -->

<!-- Loading -->
<p *ngIf="action.isLoading">⌛ Loading...</p>

<!-- start -->
<!-- <button (click)="action.isStart ? action.stop() : action.start()">
  {{ action.isStart ? "Stop" : "Start" }}
</button> -->

<button
  class="btn"
  [class.btn-info]="!action.isStart"
  [class.btn-warning]="action.isStart"
  [disabled]="action.isLoading"
  (click)="handle(action, action.isStart ? 'stop' : 'start')"
>
  <img
    [src]="
      action.isStart
        ? 'https://id1945.github.io/images/svg/camera-off.svg'
        : 'https://id1945.github.io/images/svg/camera-on.svg'
    "
    width="30px"
  />
</button>
